var React = require('react');

function BracketsCurly (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.4 16c.42.35.76.79 1 1.28.6 1.24.6 2.75.6 4.22 0 3.04.12 4.5 3 4.5a1 1 0 0 1 0 2c-2.19 0-3.67-.77-4.4-2.28C5 24.48 5 22.97 5 21.5c0-3.04-.13-4.5-3-4.5a1 1 0 0 1 0-2c2.87 0 3-1.46 3-4.5 0-1.46 0-2.98.6-4.22C6.34 4.77 7.82 4 10 4a1 1 0 1 1 0 2c-2.88 0-3 1.46-3 4.5 0 1.46 0 2.98-.6 4.22-.24.5-.58.93-1 1.28ZM30 15c-2.88 0-3-1.46-3-4.5 0-1.46 0-2.98-.6-4.22C25.67 4.77 24.19 4 22 4a1 1 0 1 0 0 2c2.88 0 3 1.46 3 4.5 0 1.46 0 2.98.6 4.22.23.5.58.93 1 1.28-.42.35-.77.79-1 1.28-.6 1.24-.6 2.75-.6 4.22 0 3.04-.13 4.5-3 4.5a1 1 0 0 0 0 2c2.18 0 3.66-.77 4.4-2.28.6-1.24.6-2.75.6-4.22 0-3.04.13-4.5 3-4.5a1 1 0 0 0 0-2Z"}));
}

BracketsCurly.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = BracketsCurly;

BracketsCurly.default = BracketsCurly;
